

























































































































import { Component, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import IntegrationSystemIdConstants from '@/models/Integrations/IntegrationSystemIdConstants';

@Component({
    name: 'MicrosoftGoogleSettingsEdit'
})
export default class MicrosoftGoogleSettingsEdit extends GiganautVueDialog {
  // Capabilities
  public ssoEnabled = false;
  public mailboxSyncEnabled = false;

  // SSO Configuration
  public tenantId = '';
  public emailDomains = '';

  @Watch('dialog')
  onDialogChanged(val: boolean) {
    if (val) {
      // Reset form
      this.ssoEnabled = false;
      this.mailboxSyncEnabled = false;
      this.tenantId = '';
      this.emailDomains = '';

      // Load existing values from integration settings
      const integration = AgencySettingsModule.currentIntegration;
      if (integration && integration.settings) {
        for (const setting of integration.settings) {
          switch (setting.key) {
            case 'sso_enabled':
              this.ssoEnabled = setting.value === 'true';
              break;
            case 'mailbox_sync_enabled':
              this.mailboxSyncEnabled = setting.value === 'true';
              break;
            case 'tenant_id':
              this.tenantId = setting.value;
              break;
            case 'email_domain':
              this.emailDomains = setting.value;
              break;
          }
        }
      }
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  get isMicrosoft() {
    const integration = AgencySettingsModule.currentIntegration;
    return integration && integration.integrationSystemId === IntegrationSystemIdConstants.Microsoft365;
  }

  get canSave() {
    // At least one capability must be enabled
    if (!this.ssoEnabled && !this.mailboxSyncEnabled) {
      return false;
    }
    // If SSO is enabled, validate SSO config
    if (this.ssoEnabled) {
      // Email domains required
      if (!this.emailDomains.trim()) {
        return false;
      }
      // Tenant ID required for Microsoft
      if (this.isMicrosoft && !this.tenantId.trim()) {
        return false;
      }
    }
    return true;
  }

  async save() {
    if (!this.canSave) {
      return;
    }

    const integration = AgencySettingsModule.currentIntegration;

    // Build the settings to save
    const request = {
      updatedAt: integration.updatedAt,
      ssoEnabled: this.ssoEnabled,
      mailboxSyncEnabled: this.mailboxSyncEnabled,
      emailDomains: this.emailDomains.trim(),
      tenantId: this.tenantId.trim()
    };

    await AgencySettingsModule.editMicrosoftGoogleSettings(request);
    this.dialog = false;
  }
}
